import HistorySection from './HistorySection';

export default HistorySection;
